var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Button } from '../button';
import { useModal } from './modal-context';
import { buttonStaticStyle } from './styles';
function ButtonInternal(_a, ref) {
    var restProps = __rest(_a, []);
    const { size } = useModal();
    return (_jsx(Button, Object.assign({ css: buttonStaticStyle, ref: ref, size: size }, restProps)));
}
export default ButtonInternal;
